import Component from './Component';
import { AnimationClipEvent } from '../System/Animation/AnimationClip';

export default class AnimationComponent extends Component {
    public _isPlaying: boolean = false;
    public playOnStart: boolean = undefined;
    public clipName: string = undefined;
    public timeScaleContext: 'local' | 'global' = 'global';
    public timeScale: number = 1;
    public meta?: any = undefined;

    public set isPlaying(value: boolean) {
        if (value !== this._isPlaying) {
            this.gameObject.emit(
                value ? AnimationClipEvent.START : AnimationClipEvent.COMPLETE
            );
        }
        this._isPlaying = value;
    }

    public get isPlaying(): boolean {
        return this._isPlaying;
    }
}
